import type { QRType } from "@/pages/generator/page";

const types: { id: QRType; icon: string; label: string; desc: string }[] = [
  { id: "url", icon: "ri-links-line", label: "İnternet Sitesi", desc: "Web URL'sine yönlendir" },
  { id: "vcard", icon: "ri-contacts-line", label: "vCard", desc: "Dijital kartvizit" },
  { id: "wifi", icon: "ri-wifi-line", label: "WiFi", desc: "Ağa bağlan" },
  { id: "text", icon: "ri-text", label: "Metin", desc: "Düz metin içeriği" },
  { id: "email", icon: "ri-mail-line", label: "E-posta", desc: "E-posta gönder" },
  { id: "phone", icon: "ri-phone-line", label: "Telefon", desc: "Telefon ara" },
  { id: "instagram", icon: "ri-instagram-line", label: "Instagram", desc: "Instagram profili" },
  { id: "whatsapp", icon: "ri-whatsapp-line", label: "WhatsApp", desc: "WhatsApp mesajı" },
  { id: "facebook", icon: "ri-facebook-line", label: "Facebook", desc: "Facebook sayfası" },
  { id: "pdf", icon: "ri-file-pdf-line", label: "PDF", desc: "PDF dosyası" },
];

interface Props {
  selected: QRType;
  onSelect: (type: QRType) => void;
}

export default function QRTypeSelector({ selected, onSelect }: Props) {
  return (
    <div>
      <h2 className="text-xl font-bold text-slate-900 mb-2">QR Kod Türünü Seçin</h2>
      <p className="text-sm text-slate-500 mb-6">İhtiyacınıza uygun QR kod türünü seçin ve devam edin.</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 gap-3">
        {types.map((type) => (
          <button
            key={type.id}
            onClick={() => onSelect(type.id)}
            className={`flex flex-col items-center gap-2.5 p-4 rounded-2xl border-2 transition-all cursor-pointer group ${
              selected === type.id
                ? "border-blue-400 bg-blue-50"
                : "border-slate-100 bg-white hover:border-blue-200 hover:bg-slate-50"
            }`}
          >
            <div
              className={`w-12 h-12 flex items-center justify-center rounded-xl transition-transform group-hover:scale-110 ${
                selected === type.id ? "bg-blue-100 text-blue-600" : "bg-slate-100 text-slate-500"
              }`}
            >
              <i className={`${type.icon} text-xl`}></i>
            </div>
            <div className="text-center">
              <div className={`text-xs font-bold ${selected === type.id ? "text-blue-700" : "text-slate-700"}`}>
                {type.label}
              </div>
              <div className="text-xs text-slate-400 mt-0.5">{type.desc}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
